import { useTour } from '@reactour/tour';
import confetti from 'canvas-confetti';
import { PiConfetti, PiEyeClosedBold } from 'react-icons/pi';
import { useTranslation } from 'react-i18next';

export function FinalStepContent() {
  const { setIsOpen } = useTour();
  const { t } = useTranslation();

  return (
    <div className='flex flex-col'>
      <h2 className='flex items-center gap-2 text-lg font-semibold'>
        {t('tours.mainTour.blind_mode_title')}{' '}
        <PiEyeClosedBold size={20} className='fill-white' />{' '}
      </h2>
      <br />
      {t('tours.mainTour.blind_mode_desc')}
      <button
        className='
    inline-flex items-center gap-1 justify-center px-3 py-1.5 mt-4 text-base font-medium text-white rounded-md
    bg-black hover:bg-zinc-800 transition-all
  '
        onClick={() => {
            confetti({
              spread: 160,
              particleCount: 140,
              colors: ['#0c8ce9', '#00b8db', '#00000'],
            });
          setIsOpen(false);
        }}
      >
        <PiConfetti size={20} />
        {t('tours.mainTour.blind_mode_button')}
      </button>
    </div>
  );
}
